import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Teveni';

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    const storedLang = localStorage.getItem('language');
    if (storedLang) {
      this.translateService.use(storedLang);
    } else {
      const defaultLang = 'en';
      this.translateService.use(defaultLang);
      localStorage.setItem('language', defaultLang);
    }
  }
}
